
import { RepaymentLoanResponse, ValidatePaymentResponse, GetCustomerSavedCardsResult, AddNewCardResponse, FriendPaymentRequestStatusResult } from "../model/charge";
import { CustomerWalletDetails } from "../pages/customer/wallet/models/CustomerWalletDetails";
import { apiSlice } from "../stores/base/api-slice";



const serviceBaseurl = "/charge";

const chargeEndpoints = apiSlice.injectEndpoints({
    endpoints: builder => ({
         getWalletBalance: builder.query<CustomerWalletDetails | null, void>({
              queryFn: async (_, _api, _extraOptions, baseQuery) => {
                const result = await baseQuery({ url: "/charge/wallet/balance", method: "GET" });
                if (result.error) {
                  const err = result.error as any;
                  // 400 status code is valid for the client app, we copied this from the mobile app
                  if (err.status === 400 && err.data?.title?.includes("doesn't have wallet")) {
                    return { data: null };
                  }
                  return { error: result.error };
                }
                return { data: result.data as CustomerWalletDetails };
              },
              providesTags: ["CustomerDashboard", "WalletBalance"],
            }),
        createWallet: builder.mutation<CustomerWalletDetails, void>({
              query: () => ({
                url: "/charge/wallet",
                method: "POST",
              }),
              invalidatesTags: ["WalletBalance"],
            }),
        getLoanRepaymentData: builder.query<RepaymentLoanResponse, void>({
            query:() => ({
                url: `${serviceBaseurl}/repaymentLoan/get-current-repayment-loan-process`,
                method: "GET",
            }),
            providesTags: ["CustomerDashboard", "RepaymentLoan"],
        }),
        getPaymentFee: builder.mutation<any, { currency: string; amount: number}>({
          query: (body) => ({
            url: `${serviceBaseurl}/paymentHub/client-fee`,
            method: "POST",
            body
          })
        }),
        verifyTransaction: builder.query<ValidatePaymentResponse, { reference: string}>({
          query:({reference}) => ({
            url: `${serviceBaseurl}/paymentHub/verifyTransaction/${reference}`,
            method: "GET",
          })
        }),
        verifyGuestTransaction: builder.query<ValidatePaymentResponse, { reference: string; guestCustomerDetailsId: string; utilityName: string }>({
          query:({reference, guestCustomerDetailsId, utilityName}) => ({
            url: `${serviceBaseurl}/paymentHub/guest/verifyTransaction/${reference}`,
            method: "GET",
            params: { guestCustomerDetailsId, utilityName },
          })
        }),
        getCustomerSavedCards: builder.query<GetCustomerSavedCardsResult, void>({
          queryFn: async (_arg, _api, _extraOptions, baseQuery) => {
            const result = await baseQuery({ url: `${serviceBaseurl}/saved-cards`, method: "GET" });
            if (result.error) return { data: { savedCards: [] } };
            return { data: result.data as GetCustomerSavedCardsResult };
          },
        }),
        addNewCard: builder.mutation<AddNewCardResponse, { returnUrl: string }>({
          query: (body) => ({
            url: `${serviceBaseurl}/saved-cards/payment-hub/add-new-card`,
            method: "POST",
            body,
          }),
        }),
        removeCard: builder.mutation<void, { savedCardId: string }>({
          query: ({ savedCardId }) => ({
            url: `${serviceBaseurl}/saved-cards/remove`,
            method: "DELETE",
            params: { savedCardId },
          }),
        }),
        getFriendPaymentRequestByToken: builder.query<FriendPaymentRequestStatusResult, { token: string; utilityName: string }>({
          query: ({ token, utilityName }) => ({
            url: `${serviceBaseurl}/friend-payment-request/${token}`,
            method: "POST",
            body: { utilityName },
          }),
        }),
    }),
});

export const {
   useCreateWalletMutation,
   useGetWalletBalanceQuery,
   useGetLoanRepaymentDataQuery,
   useGetPaymentFeeMutation,
   useLazyVerifyTransactionQuery,
   useLazyVerifyGuestTransactionQuery,
   useLazyGetCustomerSavedCardsQuery,
   useAddNewCardMutation,
   useRemoveCardMutation,
   useGetFriendPaymentRequestByTokenQuery,
} = chargeEndpoints;
